// src/api/index.js
const BASE_URL = 'https://api-portfolio.moayadismail.com/api';

async function handleResponse(response) {
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Something went wrong');
  }
  const json = await response.json();
  if (json.status !== 200) throw new Error(json.message || 'API error');
  return json.data;
}

function getHeaders(lang) {
  return {
    'Accept-Language': lang || 'ar',
  };
}

export async function fetchServices(lang = 'ar') {
  const response = await fetch(`${BASE_URL}/services`, {
    headers: getHeaders(lang),
  });
  return handleResponse(response);
}

export async function fetchServiceBySlug(slug, lang = 'ar') {
  const response = await fetch(`${BASE_URL}/services/${slug}`, {
    headers: getHeaders(lang),
  });
  return handleResponse(response);
}

// دالة خاصة لجلب المشاريع مع pagination
export async function fetchProjects(page = 1, perPage = 6, lang = 'en') {
  const response = await fetch(`${BASE_URL}/projects?page=${page}&per_page=${perPage}`, {
    headers: { 'Accept-Language': lang }
  });
  
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.message || 'Something went wrong');
  }
  
  const json = await response.json();
  
  // التحقق من نجاح الاستجابة
  if (json.status !== 200) {
    throw new Error(json.message || 'API error');
  }
  
  // إرجاع الكائن الكامل (يحتوي على data و pagination)
  return json;
}

export async function fetchProjectBySlug(slug, lang = 'ar') {
  const response = await fetch(`${BASE_URL}/projects/${slug}`, {
    headers: getHeaders(lang),
  });
  return handleResponse(response);
}

export async function fetchSkillCategories(lang = 'ar') {
  const response = await fetch(`${BASE_URL}/skill-categories`, {
    headers: getHeaders(lang),
  });
  return handleResponse(response);
}

export async function fetchExperiences(lang = 'ar') {
  const response = await fetch(`${BASE_URL}/experiences`, {
    headers: getHeaders(lang),
  });
  return handleResponse(response);
}

export async function fetchEducations(lang = 'ar') {
  const response = await fetch(`${BASE_URL}/educations`, {
    headers: getHeaders(lang),
  });
  return handleResponse(response);
}

export async function fetchTestimonials(lang = 'ar') {
  const response = await fetch(`${BASE_URL}/testimonials`, {
    headers: getHeaders(lang),
  });
  return handleResponse(response);
}

export async function sendContactMessage(formData, lang = 'ar') {
  const response = await fetch(`${BASE_URL}/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept-Language': lang,
    },
    body: JSON.stringify(formData),
  });
  return handleResponse(response);
}